import { createUseStyles } from 'react-jss'
import { lightGrey, trafficRedDark } from '../../../../styles/const/colors'
import { defaultBorderRadius, transitionShort } from '../../../../styles/const/common'
import { selectValueSize, selectValueSizeMobile } from '../../../../components/Select/styles'
import { phonesDown } from '../../../../styles/const/breakpoints'

const useStyles = createUseStyles(theme => ({
  selectedValueWrapper: {
    minHeight: 36,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: '8px 8px 8px 13px',
    marginBottom: 8,
    border: {
      color: theme.brandPrimary,
      style: 'solid',
      width: 1,
      radius: defaultBorderRadius
    },
    [`@media screen and (${phonesDown})`]: {
      padding: '6px 8px 6px 13px',
      minHeight: 30
    }
  },
  selectedValueLabel: {
    fontSize: selectValueSize,
    lineClamp: 1,
    display: 'block',
    lineHeight: 1.125,
    wordBreak: 'break-word',
    boxOrient: 'vertical',
    height: 'auto',
    [`@media screen and (${phonesDown})`]: {
      fontSize: selectValueSizeMobile
    }
  },
  selectedValueRemove: {
    marginLeft: 10,
    cursor: 'pointer',
    width: 12,
    height: 12,
    '& path': {
      fill: lightGrey,
      transition: transitionShort
    },
    '&:hover path': {
      fill: trafficRedDark
    }
  }
}))

export default useStyles
